import styled from 'styled-components';

const ContentPageMobilStyle = styled.div`

h3 {
    padding-top:  5% ;
    font-size: 1.5em;
}

.slick-slider {
    padding: 5% 0;
}`;

export default ContentPageMobilStyle;
